export enum EstimationState {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE',
    CERTIFIED = 'CERTIFIED',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    TO_FIX = 'TO_FIX',
    CLOSED = 'CLOSED'
};